import { ChevronRight } from 'src/components/Icons/ChevronRight'
import { FulfilledIcon } from 'src/components/Icons/FulfilledIcon'
import { InView } from 'react-intersection-observer'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'

import { FreightDetailsPrice } from './FreightDetailsPrice'
import { sendShippingEvent } from '../utils/sendShippingEvent'

interface Props {
  selectedPickupPoint: {
    name: string
    shippingEstimate: string
    price: number
  } | null
  handleClickOnStore: () => void
}

export function PickupDelivery({
  selectedPickupPoint,
  handleClickOnStore,
}: Props) {
  const { shippingEstimate } = selectedPickupPoint ?? {}
  const { pageData } = useGlobalContext()
  const shippingEstimateFormatted = shippingEstimate?.trim().endsWith('bd')
    ? `${shippingEstimate.trim().slice(0, -2).trim()} dias úteis`
    : shippingEstimate?.trim().endsWith('d')
    ? `${shippingEstimate.trim().slice(0, -1).trim()} dias`
    : shippingEstimate?.trim()

  return (
    <InView
      as="div"
      triggerOnce
      onChange={(inView) => {
        if (inView) {
          sendShippingEvent({ eventName: 'store pickup', pageData })
        }
      }}
      className="flex items-start justify-between"
    >
      <div className="flex flex-col gap-2 max-w-[75%]">
        <div className="text-black text-sm leading-[21px] font-semibold flex items-center whitespace-nowrap">
          Retire em{''}{' '}
          <button
            className="text-primaryBlue underline ml-1 items-center truncate block"
            onClick={handleClickOnStore}
          >
            {selectedPickupPoint?.name}
          </button>
          <button
            className="pl-1 shrink-0 mt-[1px]"
            onClick={handleClickOnStore}
          >
            <ChevronRight width={16} height={16} color="#3643BA" />
          </button>
        </div>
        <span className="text-restructure-primary text-sm leading-[21px] font-regular flex items-center">
          <FulfilledIcon />
          Disponível após {shippingEstimateFormatted}
        </span>
        {selectedPickupPoint?.shippingEstimate === '2 horas' && (
          <span className="text-restructure-primary text-sm leading-[21px] font-regular flex items-center">
            <FulfilledIcon />
            Em estoque na loja
          </span>
        )}
      </div>
      <FreightDetailsPrice deliveryValue={selectedPickupPoint?.price} />
    </InView>
  )
}
